import { API_URL } from '@/const';
import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { MessageType } from '@/types/enums';
import { ITicketMessage, ITicket, IUser } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/my/ticketMessages';
const $urlActionsUpload = '/my/ticketMessages/actions/upload';
const $urlActionsClose = '/my/ticketMessages/actions/close';

export interface IGetRequest {
  ticketNo: string;
}

export interface IGetResult {
  ticket: ITicket;
  user: IUser;
  count: number;
  messages: ITicketMessage[];
}

export interface ISubmitRequest {
  ticketNo: string;
  messageType: MessageType;
  storageKey: string;
  content: string;
}

export interface ISubmitResult {
  message: ITicketMessage;
}

export interface IDeleteRequest {
  messageId: number;
}

export interface IUploadResult {
  messageType: MessageType;
  storageKey: string;
  content: string;
}

export interface ICloseRequest {
  ticketNo: string;
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(req: IDeleteRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: req,
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: ISubmitResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<ISubmitResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  close(req: ICloseRequest, success: (res: IBoolResult) => void) {
    request
      .post($urlActionsClose, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      });
  },

  getUploadUrl() {
    return API_URL + $urlActionsUpload;
  },
};
